import React from "react";

export class NotFoundPage extends React.Component {
  render() {
    return <div>NotFoundPage</div>;
  }
}
